
export const AuthMobilsESO = ({ auth, handleChange, error }) => {

        return (<>
                <div className="row">
                        <div className="col col-12 ">
                                <h4>
                                        Compromís familiar - ús dels mòbils
                                </h4>
                                <p>

                                        Aquest curs 2025–2026 es manté i consolida el protocol d’ús del telèfon mòbil iniciat el
                                        curs anterior, amb l’objectiu de garantir un bon clima escolar, protegir la convivència i
                                        prevenir l’ús inadequat dels dispositius.<br />
                                        Recordem que l’ús dels telèfons mòbils no està permès dins el recinte escolar, i que el
                                        centre ha establert un sistema de recollida i custòdia diària per facilitar el compliment
                                        d’aquesta norma.
                                        <br />
                                        <br />

                                        <h5>Functionament del protocol</h5>
                                        <ol>
                                                <li>A primera hora del matí, el professor/a del primer mòdul recull els mòbils apagats dels alumnes i els guarda en una caixa específica amb el nom de cada alumne/a.</li>
                                                <li>La caixa es desa en un espai tancat amb clau durant tota la jornada.</li>
                                                <li>A última hora del matí, el professor/a responsable retorna els mòbils als alumnes perquè els puguin fer servir a la sortida del centre.</li>
                                                <li>Si es veu un mòbil visible en qualsevol moment del dia (encara que no s’estigui utilitzant), aquest serà confiscat i l’alumne podrà recollir-lo al final del dia.</li>
                                                <li>Qualsevol membre del personal del centre pot requisar un dispositiu i entregar-lo a consergeria.</li>
                                                <li>Per a comunicacions urgents, les famílies poden trucar al telèfon del centre.</li>
                                                <li>El centre no es fa responsable dels mòbils que entrin al recinte escolar. Qualsevol pèrdua, robatori o desperfecte és responsabilitat exclusiva de l’alumne/a i la seva família.</li>
                                        </ol>
                                        <br />
                                </p>


                                <h5>Compromís famíliar</h5>

                                <p>
                                        Com a pare/mare/tutor/a legal de l’alumne/a matriculat:<br />
                                        <ul>
                                                <li>Accepto i respecto el protocol vigent sobre l’ús dels mòbils al centre.</li>
                                                <li>Em comprometo a reforçar el seu compliment des de casa i a col·laborar amb l’equip docent en la seva aplicació.</li>
                                                <li>Entenc que qualsevol incompliment pot comportar la retirada temporal del dispositiu i l’aplicació de mesures educatives o disciplinàries.</li>
                                        </ul>

                                        <input type="checkbox" id="authMobils" name="authMobils" value={auth} checked={auth === "1" ? true : false} onChange={(t) => { handleChange(t.target.value) }} required />
                                        <label htmlFor="authMobils"> He llegit i accepto el protocol i el compromís</label>
                                        <span id="auhtMaterial_ERROR" className="a-Form-error">{error}</span>
                                </p>


                        </div>
                </div>

                <br />

        </>)
}

export const AuthMobils = ({auth, handleChange, error }) => 
{

        return (<>
                <div className="row">
                        <div className="col col-12 ">
                                <h4>
                                        Ús del mòbil en el centre educatiu
                                </h4>
                                <p>
                                        D'acord amb el Pla de Convivència del Centre us volem informar sobre la
                                        NORMATIVA QUE REGULA L'ÚS DE TELÈFONS MÒBILS I APARELLS
                                        ELECTRÒNICS A L'INSTITUT. (basada en la Llei 12/2009, del 10 de juliol, d'Educació)  <br />

                                        <ol>

                                                <li>L'ús del mòbil i aparells de reproducció de música està prohibit en horari de classe, dins l'aula teòrica i pràctica.
                                                        L'alumnat de PFI-PTT no els podrà utilitzar tampoc en tot el centre. Per tal de respectar i garantir el dret d'imatge està totalment prohibit fer fotos i/o vídeos dins
                                                        el recinte escolar. Aquests aparells, només es podran utilitzar amb usos pedagògics quan el professor/a ho indiqui.  </li>

                                                <li>A l'aula, el telèfon mòbil haurà d'estar en silenci i guardat.</li>
                                                <li>Està totalment prohibit carregar els mòbils al centre.</li>
                                                <li>Si un/a professor/a detecta un alumne/a fent un ús incorrecte del mòbil durant la classe, pot demanar a l'alumne/a que apagui el dispositiu i el deixi a sobre de la taula del professor fins al final de la classe.</li>
                                                <li>En el cas que un/a alumne/a reincideixi es considerarà com una falta lleu i s'aplicarà el Reglament de Règim Intern del centre.
                                                        L'alumnat de PTT-PFI que usi el mòbil en hores de classe de manera reincident, un cop ha estat ja avisat marxarà cap a casa amb un comunicat d'incidència.</li>
                                                <li>EL CENTRE NO ES FA RESPONSABLE del desperfecte, de la pèrdua o sostracció dels aparells que, sota la responsabilitat de cada alumne/a, es portin a l'institut.</li>
                                        </ol>


                                        <input type="checkbox" id="authMobils" name="authMobils" value={auth} checked={auth === "1" ? true : false} onChange={(t) => { handleChange(t.target.value) }} required />
                                        <label htmlFor="authMobils"> He llegit i accepto la normativa del centre que regula l'ús del mòbil i altres aparells electrònics</label>
                                        <span id="auhtMaterial_ERROR" className="a-Form-error">{error}</span>
                                </p>


                        </div>
                </div>
                <br />

        </>)
}